import Button from "components/common/Button/Button";
import styled from "styled-components";
import theme from "themes/simple-theme";

export const ResetButton = styled.button`
  position: absolute;
  color: ${theme.color.primary};
  background: transparent;
  border: none;
  margin-top: 0.5rem;
  margin-left: 0.5rem;
`;

export const SubmitButton = styled(Button)`
  margin-top: 16px;
`;

export const SkipForNowButton = styled(Button)`
  margin-top: 1.5vh;
`;



// WEBPACK FOOTER //
// ./src/screens/Onboarding/SignUp/CustomerPersonalInfo/CustomerPersonalInfoForm.style.tsx